<template>
  <div>
    <!-- <swiper class="swiper" :options="swiperOption">
      <swiper-slide v-for="(image, index) in images" :key="index">
        <img :src="image" @click.stop style="max-height: fit-content; max-width: 100%; margin: auto;"/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" @click.stop></div>
      <div class="swiper-button-prev" slot="button-prev" @click.stop></div>
      <div class="swiper-button-next" slot="button-next" @click.stop></div>
    </swiper> -->
    <v-container class="scrolling-wrapper">
      <placeholder-image v-for="(image, index) in images" @click="swiperOption.initialSlide = index" :key="index" :url="image" class="mx-1 clickable" :height="100" :width="100"  />
    </v-container>
    <v-overlay :opacity="0.8" :value="show" @click.prevent.native="show = false">
      <v-container fluid class="max-width max-height">
        <v-col class="max-height">
        <v-row justify="end">
          <v-btn
            icon
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row class="max-height" align-content="center" align="center" justify="center">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img :src="image" @click.stop style="max-height: fit-content; max-width: 100%; margin: auto;"/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination" @click.stop></div>
            <div class="swiper-button-prev" slot="button-prev" @click.stop></div>
            <div class="swiper-button-next" slot="button-next" @click.stop></div>
          </swiper>
          <!-- <swiper class="swiper" :options="swiperOption">
            <swiper-slide v-for="(image, index) in images" :key="index">
              <img :src="image" class="screen-width" @click.stop/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination" @click.stop></div>
            <div class="swiper-button-prev" slot="button-prev" @click.stop></div>
            <div class="swiper-button-next" slot="button-next" @click.stop></div>
          </swiper> -->
        </v-row>
        </v-col>
      </v-container>
    </v-overlay>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  props: {
    images: Array,
  },
  components: {
    Swiper,
    SwiperSlide,
    PlaceholderImage: () => import('@/components/app-components/PlaceholderImage.vue'),
  },
  directives: {
    swiper: directive,
  },
  data () {
    return {
      orientation: (window.screen.orientation || {}).type || window.screen.mozOrientation || window.screen.msOrientation,
      show: false,
      swiperOption: {
        initialSlide: null,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    }
  },
  watch: {
    show () {
      if (!this.show) {
        this.swiperOption.initialSlide = null
      }
    },
    'swiperOption.initialSlide' () {
      if (this.swiperOption.initialSlide !== null) {
        this.show = true
      }
    },
  },
}
</script>

<style lang="scss">
.max-height {
  max-height: calc(100vh);
}
.max-width {
  max-width: calc(100vw);
}
.screen-width {
  width: 80%;
}
.scrolling-wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  .v-image {
    display: inline-block;
    border-radius: 5px;
  }
  .v-image:last-child, .v-image:first-child {
    margin: 0px;
  }
}
.swiper {
  *:focus {
    outline: none;
  }
  .swiper-button-next, .swiper-button-prev {
    color: white;
  }
  .swiper-pagination-bullet-active {
    background-color: white;
  }

  .swiper-slide {
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-weight: bold;
  }
}
</style>
